import { ShoppingBag } from 'lucide-react'
import { useCartStore, useUIStore } from '@/stores'
import { m, AnimatePresence } from 'framer-motion'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

interface GlobalCartButtonProps {
    onPrepareCart?: () => void
}

export const GlobalCartButton = ({ onPrepareCart }: GlobalCartButtonProps) => {
    const { toggleCart, isMobileMenuOpen } = useUIStore()
    const { totalItems } = useCartStore()
    const location = useLocation()
    const [isVisible, setIsVisible] = useState(false)
    const count = totalItems()

    const isHiddenRoute = ['/koszyk', '/zamowienie'].includes(location.pathname) || location.pathname.startsWith('/zamowienie/') || location.pathname.startsWith('/kreator') || isMobileMenuOpen

    useEffect(() => {
        setIsVisible(true)
    }, [])

    if (isHiddenRoute) return null

    return (
        <AnimatePresence>
            {isVisible && (
                <m.button
                    initial={{ scale: 0, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0, opacity: 0 }}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    onMouseEnter={onPrepareCart}
                    onFocus={onPrepareCart}
                    onClick={() => {
                        onPrepareCart?.()
                        toggleCart()
                    }}
                    className="fixed bottom-6 right-6 z-[9990] bg-primary/90 text-white p-4 rounded-full shadow-lg hover:shadow-primary/40 backdrop-blur-sm border border-white/20 flex items-center justify-center transition-all duration-300 group"
                    aria-label={count > 0 ? `Otwórz koszyk, ${count} produktów` : 'Otwórz koszyk'}
                >
                    <ShoppingBag className="h-6 w-6" aria-hidden="true" />
                    {count > 0 && (
                        <span
                            aria-hidden="true"
                            className="absolute -top-1 -right-1 h-6 w-6 bg-black text-white text-xs font-bold rounded-full flex items-center justify-center border-2 border-white"
                        >
                            {count}
                        </span>
                    )}
                </m.button>
            )}
        </AnimatePresence>
    )
}
